/** Hosts that must never send product analytics (18+ localhost visitors were measured). */
export function isLocalAnalyticsHost(hostname: string): boolean {
  const host = hostname.trim().toLowerCase();
  return host === 'localhost' || host === '127.0.0.1' || host === '::1' || host === '[::1]' || host.endsWith('.local');
}
